export default __webpack_public_path__ + "static/media/full_time.049e041a.png";